<template>
  <CRow class="mb-5">
    <CCol sm="12" class="mb-4">
      <h2 class="subTitlePage font-weight-normal">
        {{ $t('audience.organize.complete.header2.summary-report') }}
      </h2>
    </CCol>
    <CCol :sm="{ size: 6, offset: 3 }" v-if="this.notice" class="mt-5">
      <CRow>
        <CCol class="d-flex justify-content-center py-5">
          <h1 class="text-center">{{ this.notice }}</h1>
        </CCol>
      </CRow>
    </CCol>
    <!-- TODO criar componente -->
    <CCol sm="12" class="mb-4" v-else>
      <div class="d-flex flex-column justify-content-center align-items-center bg-gray-200 p-5">
        <CSpinner class="my-3" color="primary" />
        <p class="text-center mb-4">
          {{ $t('audience.organize.complete.text.desciption1') }}<br />
          {{ $t('audience.organize.complete.text.desciption2') }}
          <b>{{ $t('audience.organize.complete.text.desciption3') }}</b>
        </p>
        <CButton color="white" class="py-3 px-3" @click="goTo()">
          <router-link to="/" tag="span">{{ $t('audience.organize.complete.link.go-to') }}</router-link>
        </CButton>
      </div>
    </CCol>
    <CCol class="mt-5 mb-5" v-show="false">
      <div class="col-md-10 offset-md-1 completeSuccessBox">
        {{ $t('audience.organize.complete.text.contacts-added') }}
        <button class="btn btn-success ml-3">See your audience</button>
      </div>
      <div class="col-md-10 offset-md-1 completeDefaultBox">
        <span><strong>MAIN COLUMNS:</strong> PHONE NUMBER | EMAIL</span><br />
        <span><strong>MAIN COLUMNS:</strong> PHONE NUMBER | EMAIL</span>
      </div>
      <div class="col-md-10 offset-md-1 completeAlertBox">
        29 contacts have problems. See why below.
      </div>
      <div class="col-md-10 offset-md-1 completeDefaultBox">
        <span><strong>INVALID EMAILS</strong></span
        ><br />
        <span>We couldn't recognize these email addresses, so they ouldn't be added to your list</span>
        <table class="col-md-8 mt-3 table-complete">
          <tr>
            <td>EMAIL ADDRESS</td>
          </tr>
          <tr>
            <td>empty</td>
          </tr>
          <tr>
            <td>empty</td>
          </tr>
          <tr>
            <td>empty</td>
          </tr>
        </table>
      </div>
      <div class="col-md-10 offset-md-1 pb-5 completeDefaultBox">
        <span><strong>DUPLICATES</strong></span
        ><br />
        <span>You have duplicate elements on your main columns!</span><br />
        <span>These columns cannot have duplicate information.</span>
        <div class="row mt-3">
          <div class="col-md-4">
            <table class="col-md-12 table-complete">
              <tr>
                <td>EMAIL ADDRESS</td>
              </tr>
              <tr>
                <td>empty</td>
              </tr>
              <tr>
                <td>empty</td>
              </tr>
              <tr>
                <td>empty</td>
              </tr>
            </table>
          </div>
          <div class="col-md-4">
            <table class="col-md-12 table-complete">
              <tr>
                <td>PHONE</td>
              </tr>
              <tr>
                <td>empty</td>
              </tr>
              <tr>
                <td>empty</td>
              </tr>
              <tr>
                <td>empty</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'AudienceComplete',
  components: {},
  data() {
    return {
      notice: '',
      timeout: '',
    }
  },
  mounted() {
    localStorage.removeItem('audience')
    this.$store.dispatch('audience/clearSummary')
    this.redirect()
  },
  methods: {
    redirect() {
      this.timeout = setTimeout(() => {
        this.$router.push({ name: 'import-history' })
      }, this.$configs.VUE_APP_TIME_LOADING)
    },
    goTo() {
      clearTimeout(this.timeout)
      this.$router.push({ name: 'home' })
    },
  },
  computed: {
    audienceSummary() {
      return this.$store.getters['audience/audienceSummary']
    },
  },
}
</script>
<style lang="scss">
.CSpinner {
  border: none;
  width: 83px;
  height: 83px;
  background: url(/img/icons/spinner.gif);
}
</style>
